import { MarketplaceEndSuppliersContainer } from 'components/buyer/suppliers/Suppliers/MarketplaceEndSuppliersContainer';

export const MarketplaceEndSuppliers = (): JSX.Element => (
  <MarketplaceEndSuppliersContainer />
);
